import React, { useState, useEffect } from "react";
import clinicService from "../../../../../services/clinic.service";
import userService from "../../../../../services/user.service";
import { useParams } from "react-router-dom";
import UserListItem from "./UserListItem";
//import { setClinicId,setUser } from '../../../../features/site';
import { useEyeconxStore } from "../../../../../store/eyeconxStore"

import Loading from '../../../../common/Loading'
const UsersTab = ({ setActiveTab }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { clinicId } = useParams();
  const [userList, setUserList] = useState([]);

  const setSelectedU = useEyeconxStore((state) => state.setSelectedUser);

  useEffect(() => {
    setIsLoading(true);

    userService
      .getUsers(clinicId)
      .then((res) => {
        setIsLoading(false);
        setIsSuccess(true);
        setIsError(false);
        setErrorMessage("");
        setUserList(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsSuccess(false);
        setIsError(true);
        setErrorMessage(err.response.data.message);
      });
  }, []);

  const handleReminderClick = (user) => {
    // dispatch(setClinicId(clinicId))
    //dispatch(setUser(user))
    setSelectedU(user)
    setActiveTab("clinic-user-reminder");
  };
  const handleSettingsClick = (user) => {
    // dispatch(setClinicId(clinicId))
    //  dispatch(setUser(user))
    console.log(user)
    setSelectedU(user)
    setActiveTab("clinic-user-settings");
  };
  const handleAddClick = () => {
    setActiveTab("clinic-user-add");
  };
  const roles = ["None","Admin","Manager","Doctor/ECP","Staff","Other"]
  return (
    <>
      <div className="d-flex justify-content-between">
        <h5 className="card-title" style={{ color: "#012970" }}>
          {" "}
          Users/Doctors
        </h5>
        <div>
          <button
            className="btn btn-secondary btn-sm mt-2"
            onClick={handleAddClick}
          >
            <i className="bi bi-person-plus bi-sm"></i> Add New
          </button>
          
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-12">
            <table className="table table-striped table-bordered">
              <thead>
              <tr>
                  <th>Name</th>
                  <th>Authenticated</th>
                  <th>Operations</th>
                </tr>
              </thead>
               
                <tbody>
                    {isLoading ? <Loading/>: (userList.map((user,index) =>{
                      return (
                        <tr>
                           
                            <td>
                              <div className="d-flex flex-column">
                                 
                                  <h5> {user.firstName+" "+user.lastName}</h5>
                                  <small>{roles[user.roleId]}</small>
                              </div>
                             </td>
                            <td>{user.isAuthenticated===1?"Yes":"No"}</td>
                            <td>
                                {user.roleId===3?<button className='btn btn-warning me-2' onClick={()=>handleReminderClick(user)}><i className="bi bi-alarm"></i></button>:""}
                                <button className='btn btn-secondary' onClick={()=>handleSettingsClick(user)}><i className="bi bi-gear"></i></button>
                            </td>
                        </tr>
                      )
                    }))}
                </tbody>
            </table>
        </div>
      </div>
     
    </>
  );
};

export default UsersTab;
